import React from 'react';
import PropTypes from 'prop-types';
import { consistentString } from '../../utils/content-formatting';
import { Container } from '../styled/containers';
import ContentBlockAltItem from './content-block-alt-item';
import { ContentBlockWrapper, Header } from './styles';

const isOdd = (i) => i % 2 !== 0;
const getBackgroundColor = (colorTheme, i) => {
  switch (colorTheme) {
    case 'black':
      return 'dark';
    case 'white':
      return 'light';
    case 'black-white':
      return isOdd(i) ? 'light' : 'dark';
    case 'white-black':
      return isOdd(i) ? 'dark' : 'light';
    default:
      // black-white
      return isOdd(i) ? 'light' : 'dark';
  }
};

/*
 * A left / right alternating content block component with brand theme support
 */

const ContentBlockAlt = ({
  headerText,
  contentBlockData = [],
  colorTheme,
  decorated = false,
  removeMarginBottom,
}) => {
  if (contentBlockData === null || contentBlockData.length === 0) {
    return null;
  }

  return (
    <ContentBlockWrapper $removeMarginBottom={removeMarginBottom}>
      {headerText ? (
        <Container>
          <Header>{headerText}</Header>
        </Container>
      ) : null}
      {contentBlockData.map((content, i) => (
        <ContentBlockAltItem
          data={content}
          background={getBackgroundColor(colorTheme, i)}
          isOdd={isOdd(i)}
          key={content.contentful_id}
          decorated={decorated}
        />
      ))}
    </ContentBlockWrapper>
  );
};

ContentBlockAlt.propTypes = {
  headerText: PropTypes.string,
  contentBlockData: PropTypes.array.isRequired,
  colorTheme: PropTypes.oneOf(['black', 'white', 'black-white', 'white-black']),
  decorated: PropTypes.bool,
  removeMarginBottom: PropTypes.bool,
};

export default ContentBlockAlt;

export const ContentBlockAltAssembly = ({ contentfulData }) => (
  <ContentBlockAlt
    headerText={contentfulData.headerText}
    contentBlockData={contentfulData.contentBlockData}
    colorTheme={consistentString(contentfulData.colorTheme)}
    decorated={contentfulData.decorated}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

ContentBlockAltAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
